import * as React from "react";
import { Chip, Stack, Typography } from "@mui/material";
import NewIcon from "../icons/NewIcon";

const CreatedChip = () => {
  return (
    <Chip
      label={
        <Stack alignItems={"center"} direction={"row"} gap={1}>
          <NewIcon size="xs" color="textPrimary" />
          <Typography color={"GrayText"}>New</Typography>
        </Stack>
      }
      variant="outlined"
      sx={{
        borderColor: "#7A7A7A",
      }}
    />
  );
};

export default CreatedChip;
